<template>
    <div>
        <div>{{ switchLabel }}</div>
        <div class="d-flex align-items-center switch" :class="margin">
            <div @click="toggle(false)">{{ falsyLabel }}</div>
            <div class="mx-2" @click="toggle()" style="font-size: 22px;">
                <i class="mt-1 fa fa-toggle-on text-primary" v-if="toggled" :class="classSize"></i>
                <i class="mt-1 fa fa-toggle-on fa-rotate-180 text-muted" v-if="!toggled" :class="classSize"></i>
            </div>
            <div @click="toggle(true)">{{ truthyLabel }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: false },
        size: { default: 'lg' },
        truthyLabel: { default: 'Yes' },
        falsyLabel: { default: 'No' },
        switchLabel: { default: 'Select' },
        margin: { default: 'mt-2 mb-1' }
    },

    data() {
        return {
            toggled: this.value,
        };
    },

    computed: {
        classSize() {
            return this.size ? 'fa-' + this.size : '';
        }
    },

    methods: {
        toggle(toggled = undefined) {
            this.toggled = toggled === undefined ? !this.toggled : toggled;
        },
    },

    watch: {
        toggled() {
            this.$emit('input', this.toggled);
        },
    },
}
</script>

<style lang="sass">
    .switch
        cursor: pointer
</style>
